"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const FilterStateKeysEnum_1 = __importDefault(require("@react/web/Listing/Filter/FilterStateKeysEnum"));
const makeSlugs = ['skoda', 'kia', 'volkswagen', 'hyundai', 'audi', 'bmw', 'volvo', 'toyota'];
const MakeFilterItemView = ({ makeSlug, makeFilterFormData, handleFilterChange, }) => {
    var _a;
    const make = (_a = makeFilterFormData.filter((item) => item.value === makeSlug)[0]) !== null && _a !== void 0 ? _a : null;
    const filterByMakeSlug = (filterFormDataItem) => {
        handleFilterChange(filterFormDataItem, FilterStateKeysEnum_1.default.make);
    };
    if (make === null) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    // eslint-disable-next-line import/no-dynamic-require, global-require
    const image = require(`@assets/img/makes/mini/${make.value}-mini.png`);
    return react_1.default.createElement("div", { className: `filter${make.active === true ? ' filter-active' : ''}${make.offerCount === 0 ? ' filter-disabled' : ''}`, onClick: () => filterByMakeSlug(make) },
        react_1.default.createElement("img", { src: image, width: "40", height: "40", alt: make.label, loading: "lazy" }),
        react_1.default.createElement("div", { className: "filter-label" },
            make.label,
            " (",
            make.offerCount,
            ")"));
};
const MakeFilterView = ({ makeFilterFormData, handleFilterChange, }) => react_1.default.createElement("div", { className: "subscription-make-filter" }, makeSlugs.map((makeSlug) => react_1.default.createElement(MakeFilterItemView, { key: makeSlug, makeSlug: makeSlug, makeFilterFormData: makeFilterFormData, handleFilterChange: handleFilterChange })));
exports.default = MakeFilterView;
